import { Button, Form, Modal, Select } from "antd"
import { enqueueSnackbar } from "notistack"
import { useEffect, useState } from "react"
import { GetUserRoleEmployeeList, GetUserRoleList, ManageUserAppRole, axiosErrorMessages } from "../../../API/api"
import axios, { AxiosError } from "axios";

interface AddEmployeeLicenseVersion {
    isEdit:boolean;
    editData:any;
    closeAddPopup: (data: any) => void;
  }
  
    const AddRole: React.FC<AddEmployeeLicenseVersion> = ({isEdit,editData,
        closeAddPopup,
      }) => {
    const [isOpen,setIsOpen] = useState<boolean>(true)
    const [isLoading,setIsLoading] = useState<boolean>(false)
    const [employeeList,setEmployeeList] = useState([])
    const [userRoleList,setUserRoleList] = useState([])
    const handleCloseAddEditPopup = () => {setIsOpen(false);closeAddPopup(true) }
    const onSaveStatusHandler = (formdata:any) => {
      setIsLoading(true)
      if(isEdit)
        formdata = {...formdata,employeeId:editData.employeeId}
      ManageUserAppRole(formdata)
      .then((response: any) => {
        enqueueSnackbar("Successfully Added", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsOpen(false)
        closeAddPopup(true);
      })
      .catch((error: any) => {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      
      });
    }
    const [addnewSoftwareForm] = Form.useForm()
    useEffect(() => {
        fetchEmployeeList()
        fetchUserRoles()
        
    },[])
    useEffect(() => {
      if(isEdit)
          setFormData()
    },[userRoleList])
const setFormData = () => {
    addnewSoftwareForm.setFieldsValue({
        employeeId:editData.employeeId,
        appRoleMasterId:editData.userRoleId
    })
}
const fetchUserRoles = async () => {
  try {
    setIsLoading(true);
    const response = await GetUserRoleList();
    const newData = response.data.map((employee: any, index: number) => ({
      value: employee.appRoleMasterId,
      label: employee.appRole,
    }));
    setUserRoleList(newData);
    setIsLoading(false);
  } catch (error: any) {
    enqueueSnackbar(error, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
    setIsLoading(false);
  }
}
    const fetchEmployeeList = async () => {
        try {
            setIsLoading(true);
            const response = await GetUserRoleEmployeeList();
            const newData = response.data.map((employee: any, index: number) => ({
              value: employee.employeeId,
              label: employee.employeeName,
            }));
            setEmployeeList(newData);
            setIsLoading(false);
          } catch (error: any) {
            enqueueSnackbar(error, {
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
            setIsLoading(false);
          }
    }
    const filterOption = (
        input: string,
        option?: { label: string; value: number }
      ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
    return <>
        <div>
      <Modal
        footer={null}
        title="Add/Edit User Role"
        open={isOpen}
        onCancel={handleCloseAddEditPopup}
        maskClosable={false}
      >
           { isEdit && <><strong>Employee Name: </strong>
          {editData.employeeName}</>}
          
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          onFinish={onSaveStatusHandler}
          autoComplete="off"
          form={addnewSoftwareForm}
          initialValues={{ isSoftware: false }}
        >
            
              {!isEdit && (<Form.Item
            label="Employee"
            name="employeeId"
            valuePropName="checked"
            rules={[{ required: true, message: "Select Employee" }]}

          >
    <Select
              style={{ width: "100%" }}
              placeholder="Select Employee"
              options={employeeList}
              filterOption={filterOption}
              showSearch
            />
          </Form.Item>  )}
          <Form.Item
            label="Role"
            name="appRoleMasterId"
            rules={[{ required: true, message: "Select Role" }]}

          >
    <Select
              style={{ width: "100%" }}
              placeholder="Select Role"
              options={userRoleList}
              filterOption={filterOption}
              showSearch
            />
          </Form.Item>  
          <Button className="pm-btn" type="primary" htmlType="submit">
            Save
          </Button>
            </Form></Modal></div>
    </>
}

export default AddRole